import enLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";

const localeMap = {
  en: enLocale,
  es: esLocale,
};

export { localeMap };
